module.exports = __webpack_public_path__ + "static/media/client16.99acdebf.jpg";